import md5 from "md5";
import {isEmpty, str_replace} from "../components/helpers/helpers";
import {$http} from "../helpers/http";
import {getCacheKey} from "./cache_key";

const cacheTable = 'checkLink';

export const linkTypes = {
    SEARCH: 'search',
    PROPERTY_SHOW: 'property_show',
    AREA_SHOW: 'area_show',
    QUESTION_SHOW: 'question_show',
    BLOG_SHOW: 'blog_show',
    AGENCIES_LISTS: 'agencies_lists',
};

/**
 * @param {String} url
 * @param {String} type <linkTypes>
 *
 * @return {Promise<params>}
 */
export function checkUrlParams(url, type) {
    const appUrl = process.env.NEXT_PUBLIC_APP_URL;
    const path = '/v1/links/check';

    const data = {
        url: appUrl + url
    };

    const cacheKey = getCacheKey(cacheTable, type, 'url-hash', [md5(url)]);
    const cacheTTL = 24 * 60 * 60; // second

    return new Promise((resolve, reject) => {
        $http(cacheKey, path, cacheTTL, 'post', data).then(result => {
            if (!isEmpty(result)) {
                result.link = str_replace(appUrl, '', result.link);
            }

            resolve(result);
        }).catch(error => {
            reject(error)
        })
    })
}